<template>
    <div :key="iteration">
        <input type="hidden" id="company" name="company" v-model="value" @change.stop="updateValue($event)">
    </div>
</template>

<script>
    import InvisibleSelectorWidget from './InvisibleSelectorWidget.vue';

    export default {
        extends: InvisibleSelectorWidget,
        created() {
            this.render();
        },
        methods: {
            broadcast(value) {
                window.events.emit('updateCompany', parseInt(value));
            }
        }
    }
</script>
